module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "6px 0px"
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de8969d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/title_and_slot.vue
// module id = 1025
// module chunks = 0